import { Component, OnInit } from '@angular/core';5
import { ProspectService } from 'services/prospect.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AgentShowingOption } from 'app/models/agent-showing-option';
import { SplashService } from 'services/splash.service';
import { ErrorService } from 'services/error.service';
import { TrackingParameters } from 'app/models/tracking-parameter';
import { ProspectProfileInfo } from 'app/models/prospect-profile-info';

@Component({
  selector: 'app-showing-dateselect',
  templateUrl: './showing-dateselect.component.html',
  styleUrls: ['./showing-dateselect.component.css']
})
export class ShowingDateselectComponent implements OnInit {
  selectedDate: Date = null;
  address: string = null;
  yardiKey: string = null;
  showingOptionCount: number = null;
  errorMessage: string = null;
  showLoader: boolean = false;
  tourTime: string=null;
  showings: AgentShowingOption[];
  selectedShowing: AgentShowingOption = null;
  prospectInfo: ProspectProfileInfo=new ProspectProfileInfo();
  desiredMoveInDate: Date =null;
  monthlyGrossIncome: number=null;
  isProcessing: boolean = false;
  

  constructor(public errorService: ErrorService,private prospectService: ProspectService, public router: Router, public route: ActivatedRoute, private splashService: SplashService) {
    
    let address = localStorage.getItem('PropertyAddress');
    let yardiKey = localStorage.getItem('YardiID');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.yardiKey = yardiKey;
    }
    this.prospectService.getProspectProfileInfo().subscribe(res => this.onGetProspectProfileInfo(res), res => this.errorService.showError("Error getting user information."));
   }

  ngOnInit() {
    this.splashService.updateSplash("agenttour");
  }
  onGetProspectProfileInfo(info: ProspectProfileInfo)
  {
    if(!this.isDateInPast(info.PreferredMoveIn)){
      this.prospectInfo.PreferredMoveIn=info.PreferredMoveIn;        
    }
   this.prospectInfo.IncomeAmount=info.IncomeAmount;
    
  }
  isDateInPast(chosenDate:Date): boolean{
    if(chosenDate===null) return false;
    let currentDate=new Date();
    let compareDate=new Date(chosenDate);
    currentDate.setHours(0,0,0);
    compareDate.setHours(0,0,0);
    return currentDate>compareDate;

  }
  onSubmit(){


    this.isProcessing = true;   
    this.LoadFromLocalTourQueryParams();
    this.prospectService.updateProspectProfileInfo(this.prospectInfo).subscribe(res => this.updateSuccess(res), res => this.errorService.showError("Error updating user info."));
  }

  updateSuccess(res: boolean){
    this.prospectService.createShowingForProspect(this.selectedShowing).subscribe(res => this.onCreateShowing(res), res => this.errorMessage ="Error creating showing.");

  }
  dateSelected(e)
  {
    this.showLoader = true;
    if(e.value !== null){
      this.selectedDate = new Date(e.value);
      this.showingOptionCount = null;
      this.showLoader = true;
      this.prospectService.getShowingOptions(this.yardiKey, e.value).subscribe(res => this.onGetShowingOptions(res), res => this.errorMessage = "Error getting showings options.");
    } else {
      this.selectedDate = null;

    }
  }


  onGetShowingOptions(options: AgentShowingOption[])
  {
    this.showLoader = true;
    this.showingOptionCount = options.length;
    this.showings = options;
    if(options == null || options.length == 0) {
      this.errorService.showError("No showing times found")
    }
    this.selectedShowing=null;
    this.showLoader = false;
  }
  onError(msg) {
    this.errorService.showError(msg);
  }

  onCreateShowing(showingKey: number)
  {
    this.router.navigate(['/tour/toursummary', showingKey]);
  }

  LoadFromLocalTourQueryParams()
  {
      let paramsString = localStorage.getItem('TrackingParameters');

      if (paramsString)
      {
          let params: TrackingParameters = JSON.parse(paramsString);
          this.selectedShowing.ProspectSource = params.Source;
          this.selectedShowing.Campaign = params.Campaign;
          this.selectedShowing.AdGroup = params.AdGroup;
          this.selectedShowing.Keyword = params.Keyword;
          this.selectedShowing.AdCopy = params.AdCopy;
          this.selectedShowing.Device = params.Device;
          this.selectedShowing.Medium = params.Medium;
      }
  }  
}
